import Debouncer from 'goog:goog.async.Debouncer';

export function useDebounce(callback, delayInterval) {
  const debouncer = React.useRef(new Debouncer(callback, delayInterval));

  const debouncedCallback = React.useCallback((...params) => {
    debouncer.current.fire(...params);
  }, []);

  const dispose = React.useCallback(() => {
    const currentDebouncer = debouncer.current;
    return () => currentDebouncer.dispose();
  }, []);

  React.useEffect(() => dispose, [dispose]);

  return {debouncedCallback, dispose};
}
